import React, { useState, useCallback } from 'react';
import {
  getToken, getSessionItem, getSessionJSON, SESSION_KEYS,
} from '../utils/authStorage';

const AuthContext = React.createContext();

// TENANT_PAINEL é gravado direto (Login/Header) e pode acabar com os literais
// 'undefined'/'null' ou uma string vazia. Como texto esses valores são truthy: passariam pelas
// guardas `if (!tenant)` das telas e o backend responderia 400. Normalizamos na origem para que
// "tenant ausente" seja sempre `undefined`. Exportada para ser testável e para os pontos que
// GRAVAM o valor (Login/Header) poderem normalizar antes de persistir.
export const normalizarTenant = (valor) => {
  if (typeof valor !== 'string') return valor || undefined;
  const tenantNormalizado = valor.trim();
  if (!tenantNormalizado || tenantNormalizado === 'undefined' || tenantNormalizado === 'null') {
    return undefined;
  }
  return tenantNormalizado;
};

function AuthProvider(props) {
  // O token vive no localStorage (sem limite de ~4KB do cookie) porque o JWT
  // embute o perfil completo e pode estourar o cookie, sumindo no reload da
  // troca de empresa. `getToken` promove a sessão que ainda estiver no cookie.
  const [token, setTokenContext] = useState(() => getToken());
  const [username, setUsernameContext] = useState(() => getSessionItem(SESSION_KEYS.USERNAME));
  const [fullname, setFullnameContext] = useState(() => getSessionItem(SESSION_KEYS.FULLNAME));
  const [companies, setCompaniesContext] = useState(() => getSessionJSON(SESSION_KEYS.COMPANIES));
  const [selectedCompanies, setSelectedCompaniesContext] = useState(
    () => getSessionJSON(SESSION_KEYS.SELECTED_COMPANIES),
  );
  const [tenant, setTenant] = useState(() => normalizarTenant(getSessionItem(SESSION_KEYS.TENANT)));
  // `useCallback` para preservar a estabilidade referencial que o setter do `useState` tem por
  // contrato: sem isso, um consumidor que coloque `setTenantContext` num array de dependências
  // (`useEffect`/`useCallback`) passaria a re-executar o efeito a cada render do Provider.
  const setTenantContext = useCallback((valor) => setTenant(normalizarTenant(valor)), []);

  return (
    <AuthContext.Provider value={{
      token,
      setTokenContext,
      username,
      setUsernameContext,
      fullname,
      setFullnameContext,
      companies,
      setCompaniesContext,
      selectedCompanies,
      setSelectedCompaniesContext,
      tenant,
      setTenantContext,
    }}
    >
      {props.children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };
